<router-outlet />
@defer (on idle) {
  <app-toast />
}
